var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerFav(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_4178)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16675 7.50033C4.16675 4.27533 6.77508 1.66699 10.0001 1.66699C13.2251 1.66699 15.8334 4.27533 15.8334 7.50033C15.8334 11.8753 10.0001 18.3337 10.0001 18.3337C10.0001 18.3337 4.16675 11.8753 4.16675 7.50033ZM9.42008 11.4249L10.0001 12.0003L10.5801 11.4292L10.5959 11.4136C12.647 9.38202 14.0001 8.04189 14.0001 6.39815C14.0001 5.05537 13.0321 4.00033 11.8001 4.00033C11.1041 4.00033 10.4361 4.35346 10.0001 4.9115C9.56408 4.35346 8.89608 4.00033 8.20008 4.00033C6.96808 4.00033 6.00008 5.05537 6.00008 6.39815C6.00008 8.04475 7.35785 9.38668 9.41501 11.4198L9.42008 11.4249Z",
    fill: "#C83939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_4178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFav);
export default __webpack_public_path__ + "static/media/marker-fav.1736e8f0cdabea7ed62feaed125d0aea.svg";
export { ForwardRef as ReactComponent };